// extracted by mini-css-extract-plugin
export default {"iconBgFix":"IconWithInclusionType-module__iconBgFix___LkFbT"};